import { PropsWithChildren, useContext, useEffect, useRef, useState } from 'react'
import { MapContext } from '../MapContext'
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { TileLayerContext } from './TileLayerContext';
import { TileWMS } from 'ol/source';
import ImageWMS from 'ol/source/ImageWMS';
import ImageLayer from 'ol/layer/Image';
import { getRenderPixel } from "ol/render";
import { useAppSelector } from '../../../../../state/hooks';
import { RootState } from '../../../../../state/store';
import { Project, LayerGroup, Layer } from '../../../../../util/model/project';
import { Overlay } from 'ol';
import ImageSource from 'ol/source/Image';
interface Props {
    url: string;
    visible: boolean;
    layername?: string;
    opacity?: number;
    swipeRef: React.ForwardedRef<HTMLInputElement>;
}
interface Item {
    priority?: number | null
}
export const Tile = (props: PropsWithChildren<Props>) => {
    const map = useContext(MapContext)
    const t = useRef<TileLayer<any>>(new TileLayer())
    const swipe = typeof props.swipeRef === 'function' 
    ? null 
    : props.swipeRef?.current;
    const swipeVisibility: any = useAppSelector(state => state.buttonState.swipeButton);
    const services: any = useAppSelector(state => state.layer.services);
    const projectsSwipe: Project[] = useAppSelector((state: RootState) => state.layer.projectsSwipe);
    const projects: Project[] = useAppSelector((state: RootState) => state.layer.projects);
    const [swipeLayers, setSwipeLayers] = useState<ImageLayer<ImageSource>[]>([]);
    const [overlay, setOverlay] = useState<Overlay | null>(null)
    const layerFilterCql : any = useAppSelector(state => state.table.layerFilterCql);
    const [cqlFilter, setCqlFilter] = useState<any>([])
    const visibleDomains = useAppSelector(state => state.layer.visibleDomains)
    const [layerNames__, setLayerNames__] = useState<any>([])

    useEffect(() => {
        const filterByLayer: any = []
        visibleDomains.map((domain: any) => {
            layerNames__.map((layername: any) => {
                if (domain.layername === layername) {
                    filterByLayer.push(domain)
                }
            })
        })
        setCqlFilter([...filterByLayer])
    }, [visibleDomains, layerNames__])

     const sortNullishValues = (arr: Item[] = []): Item[] => {
        const assignValue = (val: number | null | undefined): number => {
          return val === null || val === undefined ? Infinity : val;
        }
        const sorter = (a: Item, b: Item): number => {
          return assignValue(a.priority ?? 1) - assignValue(b.priority ?? 1);
        };
        return [...arr].sort(sorter);
      }

     useEffect(() => {
        const canvasOverlay: any = document.createElement('canvas');
        const ctx = canvasOverlay.getContext('2d');
        const canvasOverlay1 = new Overlay({
            element: canvasOverlay,
            positioning: 'center-center',
            stopEvent: false,
            id: 'canvasOverlay1'
        });
    
        const devicePixelRatio = window.devicePixelRatio || 1;
        
        if (swipeVisibility) {
            setOverlay(canvasOverlay1);
            let exactSwipePosition = 0;
            map.on('postrender', () => {
                const mapSize = (map as any).getSize();
                canvasOverlay.width = mapSize[0] * devicePixelRatio;
                canvasOverlay.height = mapSize[1] * devicePixelRatio;
                canvasOverlay.style.width = `${mapSize[0]}px`;
                canvasOverlay.style.height = `${mapSize[1]}px`;
                const swipePercentage = Number(swipe?.value) / 99;
                const width = Math.floor(mapSize[0] * swipePercentage);
                exactSwipePosition = width;
                ctx.clearRect(0, 0, canvasOverlay.width, canvasOverlay.height);
                ctx.save();
                ctx.scale(devicePixelRatio, devicePixelRatio);
                ctx.beginPath();
                ctx.strokeStyle = '#000000';
                ctx.lineWidth = 2;
                ctx.moveTo(width, 0);
                ctx.lineTo(width, mapSize[1]);
                ctx.stroke();
                ctx.restore();
                const center: any = map.getView().getCenter();
                canvasOverlay1.setPosition(center);
            });
            map.addOverlay(canvasOverlay1);
            
            projectsSwipe.map((project: Project) => {
                project.layer_groups.map((layerGroup: LayerGroup) => {
                    const layers_: any = [];
                    const layerNames_: any = [];
                    sortNullishValues(layerGroup.layers).map((layer: Layer | Item) => {
                        
                        if ((layer as Layer).visible) {
                            layers_.push(layer);
                            layerNames_.push((layer as Layer).name);
                        }
                    });
                    if (layers_.length) {
                        const swipeLayer = new ImageLayer({
                            source: new ImageWMS({
                                url: `${services.find((service: any) => service.id === layers_[0].service_id)?.url}` + '/wms',
                                params: {
                                    layers: layerNames_,
                                    cql_filter: layerNames_.map((layer: any) => {
                                        const cqlFilterOfLayer: any = cqlFilter.filter((filter: any) => filter.layername === layer);
                                        if (layerFilterCql.get(layer)) {
                                            const cql = layerFilterCql.get(layer).cql;
                                            if (cqlFilterOfLayer.length) {
                                                const cqlFilterT = cqlFilterOfLayer.map((domain: any) => `${domain.filterTag}=${+domain.domainId}`).join(' OR ');
                                                return `(${cql}) AND (` + cqlFilterT + ` OR ${cqlFilterOfLayer[0].filterTag} is NULL)`;
                                            } else {
                                                return cql;
                                            }
                                        } else {
                                            if (cqlFilterOfLayer.length) {
                                                const cqlFilterT = cqlFilterOfLayer.map((domain: any) => `${domain.filterTag}=${+domain.domainId}`).join(' OR ');
                                                return cqlFilterT + ` OR ${cqlFilterOfLayer[0].filterTag} is NULL`;
                                            } else {
                                                return `1=1`;
                                            }
                                        }
                                    }).join(';')
                                },
                                serverType: "geoserver",
                                crossOrigin: "anonymous",
                            }),
                            zIndex: 999999999999,
                            properties: {
                                alias: "swipe"
                            }
                        });
    
                        swipeLayer.on("prerender", (event) => {
                            const ctx:any = event.context;
                            const mapSize:any = map.getSize();
                            const width = exactSwipePosition;
                            const tl = getRenderPixel(event, [width, 0]);
                            const tr = getRenderPixel(event, [mapSize[0], 0]);
                            const bl = getRenderPixel(event, [width, mapSize[1]]);
                            const br = getRenderPixel(event, mapSize);
                            ctx.save();
                            ctx.beginPath();
                            ctx.moveTo(tl[0], tl[1]);
                            ctx.lineTo(bl[0], bl[1]);
                            ctx.lineTo(br[0], br[1]);
                            ctx.lineTo(tr[0], tr[1]);
                            ctx.closePath();
                            ctx.clip();
                        });
                        swipeLayer.on("postrender", (event) => {
                            const ctx:any = event.context;
                            ctx.restore();
                        });
    
                        map.addLayer(swipeLayer);
                        setSwipeLayers([...swipeLayers, swipeLayer]);
                    }
                });
            })
            projects.map((project: Project) => {
                project.layer_groups.map((layerGroup: LayerGroup) => {
                    const layers_: any = [];
                    const layerNames_: any = [];
                    sortNullishValues(layerGroup.layers).map((layer: any) => {
                        if (layer.visible) {
                            layers_.push(layer);
                            layerNames_.push(layer.name);
                        }
                    });
                    setLayerNames__(layerNames_);
                    if (layers_.length) {
                        const leftLayer = new ImageLayer({
                            source: new ImageWMS({
                                url: `${services.find((service: any) => service.id === layers_[0].service_id)?.url}` + '/wms',
                                params: {
                                    layers: layerNames_,
                                    cql_filter: layerNames_.map((layer: any) => {
                                        const cqlFilterOfLayer: any = cqlFilter.filter((filter: any) => filter.layername === layer);
                                        if (layerFilterCql.get(layer)) {
                                            const cql = layerFilterCql.get(layer).cql;
                                            if (cqlFilterOfLayer.length) {
                                                const cqlFilterT = cqlFilterOfLayer.map((domain: any) => `${domain.filterTag}=${+domain.domainId}`).join(' OR ');
                                                return `(${cql}) AND (` + cqlFilterT + ` OR ${cqlFilterOfLayer[0].filterTag} is NULL)`;
                                            } else {
                                                return cql;
                                            }
                                        } else {
                                            if (cqlFilterOfLayer.length) {
                                                const cqlFilterT = cqlFilterOfLayer.map((domain: any) => `${domain.filterTag}=${+domain.domainId}`).join(' OR ');
                                                return cqlFilterT + ` OR ${cqlFilterOfLayer[0].filterTag} is NULL`;
                                            } else {
                                                return `1=1`;
                                            }
                                        }
                                    }).join(';')
                                },
                                serverType: "geoserver",
                                crossOrigin: "anonymous",
                            }),
                            zIndex: 999999999999,
                            properties: {
                                alias: "swipe-left"
                            }
                        });
                        leftLayer.on("prerender", (event) => {
                            const ctx:any = event.context;
                            const width = exactSwipePosition;
                            const renderPos = getRenderPixel(event, [width, 0]);
                            ctx.save();
                            ctx.beginPath();
                            ctx.rect(0, 0, renderPos[0], event?.context?.canvas.height);
                            ctx.clip();
                        });
                        leftLayer.on("postrender", (event) => {
                            const ctx: any = event.context;
                            ctx.restore();
                        });
                        map.addLayer(leftLayer);
                    }
                });
            });

            
            if (swipe && typeof swipe === 'object' && 'addEventListener' in swipe) {
                (swipe as any).addEventListener('change', handleSwipeChange);
            }
        }
        return () => {
            const layers = map.getLayers().getArray();
            for (const lyr of layers) {
                if (lyr.getProperties().alias === "swipe" || lyr.getProperties().alias === "swipe-left") {
                    lyr.setVisible(false)
                }
            }
            if (swipe && typeof swipe === 'object' && 'removeEventListener' in swipe) {
                (swipe as any).removeEventListener('change', handleSwipeChange);
            }
            if (map) {
                map.removeOverlay(canvasOverlay1);
            }
        }
    }, [projectsSwipe, swipeVisibility, projects]);

    const handleSwipeChange = () => {
        map.render();
    };

    useEffect(() => {
        if (swipeVisibility) {

            swipe?.addEventListener("input", handleSwipeChange);
            swipe?.addEventListener("change", handleSwipeChange);
    
            return () => {
                swipe?.removeEventListener("input", handleSwipeChange);
                swipe?.removeEventListener("change", handleSwipeChange);
            };
        } else{
            if (overlay) {
                map.removeOverlay(overlay);
            }
        }
    }, [swipeVisibility]);

    useEffect(() => {
        const tileLayer = t.current!;
        if (!props.layername) {
            tileLayer.setSource(new XYZ({
                url: props.url,
                crossOrigin: "anonymous"
            }));
            tileLayer.setVisible(props.visible);
            tileLayer.setZIndex(-1)
        }

        else {
            tileLayer.setSource(new TileWMS({
                url: props.url,
                params: { 'LAYERS': `${props.layername}`, 'TILED': true },
                serverType: 'geoserver',
                crossOrigin: "Anonymous"
            }))
            tileLayer.setZIndex(10)
            tileLayer.setVisible(props.visible)
        }
        map.addLayer(tileLayer);

        return () => {
            map.removeLayer(tileLayer);
        }
    }, []);


    useEffect(() => {
        const tileLayer = t.current!;
        if (props.opacity) {
            tileLayer.setVisible(true)
            tileLayer.setOpacity(props.opacity / 100)
        }
    }, [props.opacity])

    return <TileLayerContext.Provider value={t.current}>{props.children}</TileLayerContext.Provider>;
}